import React from "react";
import { Star } from "lucide-react";

const StarRating = ({ rating, maxRating = 5, size = 20, inactive = false }) => {
  // Enhanced validation and safe parsing
  const parseRating = (value) => {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const parsed = Number(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const safeRating = parseRating(rating);
  const clampedRating = Math.max(0, Math.min(safeRating, maxRating));

  console.log("StarRating Debug:", {
    originalRating: rating,
    safeRating,
    clampedRating,
    inactive
  });

  const renderStar = (index) => {
    const starValue = index + 1;
    const uniqueId = `star-${index}-${Math.random().toString(36).substr(2, 9)}`;

    // If inactive, show all stars as empty/grey regardless of rating
    if (inactive) {
      return (
        <Star
          key={index}
          size={size}
          stroke="#D1D5DB"
          fill="none"
        />
      );
    }

    // Calculate how much of this star should be filled
    let fillPercentage = 0;
    if (clampedRating >= starValue) {
      // Full star
      fillPercentage = 100;
    } else if (clampedRating > starValue - 1) {
      // Partial star
      fillPercentage = (clampedRating - (starValue - 1)) * 100;
    }

    if (fillPercentage === 0) {
      // Empty star
      return (
        <Star
          key={index}
          size={size}
          stroke="#D1D5DB"
          fill="none"
        />
      );
    } else if (fillPercentage === 100) {
      // Full star
      return (
        <Star
          key={index}
          size={size}
          fill="#F59E0B"
          stroke="#F59E0B"
        />
      );
    } else {
      // Partial star using SVG gradient
      return (
        <div key={index} className="relative inline-flex items-start">
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            className="inline-block"
          >
            <defs>
              <linearGradient id={uniqueId} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop
                  offset={`${fillPercentage}%`}
                  stopColor="#F59E0B"
                />
                <stop
                  offset={`${fillPercentage}%`}
                  stopColor="transparent"
                />
              </linearGradient>
            </defs>
            <path
              d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
              fill={`url(#${uniqueId})`}
              stroke="#F59E0B"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {/* Background empty star */}
            <path
              d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
              fill="none"
              stroke="#D1D5DB"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="absolute inset-0"
            />
          </svg>
        </div>
      );
    }
  };

  return (
    <div className="flex gap-1" role="img" aria-label={`Rating: ${clampedRating} out of ${maxRating} stars`}>
      {Array.from({ length: maxRating }).map((_, index) => renderStar(index))}
    </div>
  );
};

export default StarRating;
